import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersFacade } from '@app/shared/+state/users';
import { EntitlementEnum } from '@app/shared/interfaces';
import { UserManagementUser } from '@app/shared/models/user-management-user';
import { UserManagementService } from '@app/shared/services/user-management/user-management.service';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
})
export class UserManagementComponent implements OnInit {
  loading = true;
  users$: Observable<UserManagementUser[]> = this.userMgtService.users$;

  _searchCriteria: string;
  get searchCriteria(): string {
    return this._searchCriteria;
  }
  set searchCriteria(value: string) {
    this.userMgtService.applySearchToUsers(value);
  }

  entitlements$ = this.usersFacade.entitlementForFeature$(EntitlementEnum.MaxSecondaryUsers);

  // We don't currently update the user transformer on page load, and I don't think we should right now
  // We'll ignore the current number of users from the entitlement and use it from the fetched user data
  isAtLimit$ = combineLatest([this.entitlements$, this.users$]).pipe(
    map(([entitlement, users]) => {
      return users?.length >= +entitlement.value;
    })
  );

  constructor(
    private userMgtService: UserManagementService,
    private router: Router,
    private usersFacade: UsersFacade
  ) { }

  ngOnInit() {
    this.refreshUsersFromApi();
  }

  refreshUsersFromApi() {
    this.userMgtService.getUsersFromApi().subscribe();
  }

  addNewClicked() {
    this.router.navigate(['/settings/user-management/invite']);
  }

  deleteUser(user: UserManagementUser) {
    user.deleting = true;

    this.userMgtService.deleteUser(user.id).subscribe();
  }
}
